export { default as ProductPrice } from './product-price'
